import { Category } from '~apis/cash-flow-overview/getCategories';
import { TaxInvoice } from '~models/tax-invoice';

type SkipReason = 'NO_MAPPING' | 'NOT_REPORTED_YET';

export type ExtraMappingOption =
  | 'MINOR_IGNORED'
  | 'DISCOUNT_GIVEN'
  | 'MISC_WITHDRAWAL'
  | 'MISC_DEPOSIT'
  | 'DISCOUNT_RECEIVED'
  | null
  | 'EXTRA_PURCHASE'
  | 'EXTRA_SALES';
export interface Mapping {
  accountId: number;
  labelId?: number;
  transactionId: number;
  category: Category;
  taxInvoices?: TaxInvoice[];
  skipReason?: SkipReason;
  ignoreDiffReason?: ExtraMappingOption;
  memo?: string;
  businessEntityId?: number | null;
  businessEntityLabel?: string;
  customLabelId: number | null;
  companySpecificCategoryId?: number | null;
}

export const BUSINESS_ENTITY_RULE_LABEL_STORAGE_KEY = 'businessEntityRuleLabel';
